import Vue from "vue";
import moment from "vue-moment";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import VueGtag from "vue-gtag";
import store from "./store";
import env from "./env";
import "./styles/index.css";
import titleMixin from "./mixins/titleMixin";

//include mixin globally @TODO do same for filters
Vue.mixin(titleMixin);

Vue.config.productionTip = false;
// Vue.use(require('vue-moment'));
Vue.use(moment);

Vue.use(VueGtag, {
	config: { id: "G-8F2QNW5K5G" },
});
// Vue filters for formatting
Vue.filter("toCurrency", function (value: any) {
	if (isNaN(parseFloat(value))) {
		return value;
	}
	var formatter = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 0,
	});
	value = formatter.format(value);
	if (value.charAt(value.length - 2) == ".") {
		value = value + "0";
	}
	return value;
});

Vue.filter("toCapitalize", function (value: any) {
	if (value == undefined || value == null) return value;
	const valueFix = value.toString();
	return valueFix.charAt(0).toUpperCase() + valueFix.slice(1).toLowerCase();
});

Vue.filter("toThousands", function (value: any) {
	//if value number and more than 3 ch
	if (value == undefined || value == null) return value;
	if (value.toString().match(/^[0-9]+$/) !== null && value.length > 3) {
		return value.replace(/(?=(\d{3})+(?!\d))/g, ",");
	} else {
		return value;
	}
});
Vue.filter("numberWithCommas", function (value: any) {
	if (value == undefined || value == null) return value;
	value = Number(value).toFixed(2);
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.filter("propertyClassificationFormat", function (value: any) {
	if (value == undefined || value == null) return value;
	const valueString = value.toString();
	return valueString.substring(0, 1) + "-" + valueString.substring(1, value.length);
});
Vue.filter("capitalizeName", function (value: any) {
	if (value == undefined || value == null) return value;
	return value.replace(/\b(\w)/g, (s: string) => s.toUpperCase());
});
env();

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
